import { DataGridAlphaV3 as DataGrid } from "../../lib/DataGridAlphaV3";
import { type DataGridProps } from "../../lib/DataGridAlphaV3/Props";

export const DataGridAlphaV3: React.FC<DataGridProps<unknown, unknown>> = (props) => {
	return <DataGrid {...props} />;
};
